import {BaseClient} from "../../Api/HttpClient";
import toast from "react-hot-toast";
import i18next from "i18next";

export const createExceptionRateSlice = (set, get) => ({
    exceptionRates: [],

    getExceptionRatesForFreelancer: async (freelancerId) => {
        try {
            const response = await BaseClient().get(`/freelancers/${freelancerId}/exception-rates`);
            if (response.status === 200) {
                const data = response.data.data || response.data;
                set({ exceptionRates: data });
                return data;
            }
        } catch (error) {
            console.error('Error fetching exception rates', error);
            toast.error(i18next.t('exception_rates.toast_fetch_error'));
            return [];
        }
    },

    createExceptionRate: async (freelancerId, data) => {
        try {
            const response = await BaseClient().post(`/freelancers/${freelancerId}/exception-rates`, data);
            if (response.status === 200 || response.status === 201) {
                toast.success(i18next.t('exception_rates.toast_create_success'));
                await get().getExceptionRatesForFreelancer(freelancerId);
                return response.data;
            }
        } catch (error) {
            console.error('Error creating exception rate', error);
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(i18next.t('exception_rates.toast_create_error'));
            }
            throw error;
        }
    },

    updateExceptionRate: async (freelancerId, exceptionRateId, data) => {
        try {
            const response = await BaseClient().patch(`/freelancers/${freelancerId}/exception-rates/${exceptionRateId}`, data);
            if (response.status === 200) {
                toast.success(i18next.t('exception_rates.toast_update_success'));
                await get().getExceptionRatesForFreelancer(freelancerId);
                return response.data;
            }
        } catch (error) {
            console.error('Error updating exception rate', error);
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(i18next.t('exception_rates.toast_update_error'));
            }
            throw error;
        }
    },

    deleteExceptionRate: async (freelancerId, exceptionRateId) => {
        try {
            const response = await BaseClient().delete(`/freelancers/${freelancerId}/exception-rates/${exceptionRateId}`);
            if (response.status === 200) {
                toast.success(i18next.t('exception_rates.toast_delete_success'));
                await get().getExceptionRatesForFreelancer(freelancerId);
                return true;
            }
        } catch (error) {
            console.error('Error deleting exception rate', error);
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(i18next.t('exception_rates.toast_delete_error'));
            }
            return false;
        }
    },
});

